var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFireplace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M8.5 30.5h23V10.92h-23z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M11.517 28.427h17.009V12.916H11.517z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M22.625 24.021h3.715l1.65 4.406H12.01l1.65-4.406h3.759M13.869 12.81v11.21M26.312 12.81v11.21M20.429 25.39l3.025 1.697M21.703 24.995h2.66M15.637 24.995h2.566M19.5 25.43l-2.954 1.657"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M18.497 18.523c.49-1.265.396-3.175.396-3.175s1.302.542 2.2 2.03c.846 1.397.047 3.48.047 3.48.623-.618.853-1.236.874-1.978.7 1.11 1.24 2.378 1.24 3.664 0 1.59-1.457 2.878-3.255 2.88-1.797-.002-3.254-1.29-3.254-2.88 0-1.549 1.175-2.53 1.752-4.02Z"
}))));
export default SvgFireplace;